let settings: any = {};
const defaults = {
  iOS: {},
  android: {},
  androidDisabled: false,
  delay: 1000,
  delta: 500,
};

export function isIOS(): boolean {
  return !!(
    navigator.userAgent.match('iPad')
    || navigator.userAgent.match('iPhone')
    || navigator.userAgent.match('iPod')
  );
}

export function setup(options): void {
  settings = extend(defaults, options);

  if (isAndroid()) { settings.platform = 'android'; }
  if (isIOS()) { settings.platform = 'ios'; }
}

export function open(uri: string): boolean {
  if (!isIOS()) { return false; }
  window.location.href = uri;
  return true;
}

function getStoreLink(platform: string, useDesktop: boolean): string {
  const linkmap = {
    ios: settings.iOS.storeUrl || getStoreURLiOS(useDesktop),
    android: getStoreURLAndroid(),
  };

  if (typeof platform === 'undefined') {
    platform = settings.platform;
  }

  return linkmap[platform];
}


export function openStoreLink(): void {
  const storelink = getStoreLink(settings.platform, false);
  if (storelink) {
    (window.location as any) = storelink;
  }
}

function isAndroid(): boolean {
  return !!navigator.userAgent.match('Android');
}

function getStoreURLiOS(useDesktop: boolean): string | null {
  const scheme = useDesktop ? 'https' : 'itms-apps';
  const baseurl = `${scheme}://itunes.apple.com/app/`;
  const name = settings.iOS.appName;
  const id = settings.iOS.appId;
  return id && name ? `${baseurl + name}/id${id}?mt=8` : null;
}

function getStoreURLAndroid(): string {
  return `https://play.app.goo.gl/?link=${settings.android.storeUrl}`;
}

function extend(localDefaults, options): any {
  const extended = {};
  for (const key of Object.keys(localDefaults)) {
    extended[key] = localDefaults[key];
  }
  for (const key of Object.keys(options)) {
    extended[key] = options[key];
  }
  return extended;
}
